// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern MCQ Result Page */

.mcqResultContainer {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mcqResultContent {
    width: 100%;
    max-width: 800px;
}

.mcqResultCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 24px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    transition: all 0.3s ease !important;
}

.mcqResultCard:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
}

.mcqResultCard .ant-card-body {
    padding: 48px !important;
}

/* Celebration Section */
.mcqResultCelebration {
    text-align: center;
    margin-bottom: 40px;
}

.mcqResultIconWrapper {
    width: 120px;
    height: 120px;
    margin: 0 auto 24px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 2px solid rgba(102, 126, 234, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 12px 32px rgba(102, 126, 234, 0.3);
    }
}

.mcqResultIcon {
    font-size: 64px !important;
    color: #667eea !important;
}

.mcqResultTitle {
    font-size: 36px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 12px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.mcqResultSubtitle {
    font-size: 18px;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
}

/* Feedback Timer */
.mcqResultFeedbackTimer {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 24px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
    border-radius: 16px;
    margin-bottom: 32px;
}

.mcqResultFeedbackTimerIcon {
    font-size: 32px !important;
    color: #667eea !important;
}

.mcqResultFeedbackTimerContent {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.mcqResultFeedbackTimerLabel {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.mcqResultFeedbackTimerValue {
    font-size: 24px;
    font-weight: 700;
    color: #f5576c;
    font-variant-numeric: tabular-nums;
}

/* Score Section */
.mcqResultScoreSection {
    margin: 32px 0;
}

.mcqResultScoreCard {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
    border: 2px solid rgba(102, 126, 234, 0.2);
    border-radius: 20px;
    padding: 32px;
    text-align: center;
    margin-bottom: 32px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.mcqResultScoreCard.descriptionType {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 40px;
}

.mcqResultCheckIcon {
    font-size: 64px !important;
    color: #10b981 !important;
}

.mcqResultDescriptionText {
    font-size: 18px;
    color: #1f2937;
    margin: 0;
    font-weight: 500;
}

.mcqResultScoreDisplay {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 12px;
    margin-bottom: 12px;
}

.mcqResultScoreValue {
    font-size: 64px;
    font-weight: 700;
    line-height: 1;
}

.mcqResultScoreDivider {
    font-size: 48px;
    font-weight: 400;
    color: #9ca3af;
}

.mcqResultScoreTotal {
    font-size: 36px;
    font-weight: 600;
    color: #6b7280;
}

.mcqResultScoreLabel {
    font-size: 16px;
    color: #6b7280;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Progress Section */
.mcqResultProgressSection {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 32px;
    background: rgba(102, 126, 234, 0.02);
    border-radius: 16px;
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.mcqResultProgressCircle {
    flex-shrink: 0;
}

.mcqResultProgressInfo {
    flex: 1 1;
}

.mcqResultProgressInfo .ant-statistic-title {
    font-size: 16px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 8px;
}

.mcqResultPerformanceText {
    font-size: 16px;
    color: #4b5563;
    line-height: 1.6;
    margin-top: 16px;
    margin-bottom: 0;
}

/* Actions */
.mcqResultActions {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    padding-top: 32px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.mcqResultButton {
    height: 56px !important;
    padding: 0 48px !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    border-radius: 16px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
}

.mcqResultButton:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;
}

.mcqResultButton:active {
    transform: translateY(0);
}

/* Legacy Styles (for compatibility) */
.result-container {
    display: none;
}

.result-card {
    display: none;
}

.thanks {
    display: none;
}

.completed {
    display: none;
}

.score {
    display: none;
}

.back-to-dashboard {
    display: none;
}

/* Responsive Design */
@media (max-width: 968px) {
    .mcqResultContainer {
        padding: 30px 40px;
    }

    .mcqResultCard .ant-card-body {
        padding: 40px !important;
    }

    .mcqResultProgressSection {
        flex-direction: column;
        gap: 24px;
        text-align: center;
    }

    .mcqResultProgressInfo {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .mcqResultContainer {
        padding: 30px 20px;
    }

    .mcqResultCard .ant-card-body {
        padding: 32px !important;
    }

    .mcqResultIconWrapper {
        width: 100px;
        height: 100px;
    }

    .mcqResultIcon {
        font-size: 52px !important;
    }

    .mcqResultTitle {
        font-size: 28px;
    }

    .mcqResultSubtitle {
        font-size: 16px;
    }

    .mcqResultScoreValue {
        font-size: 48px;
    }

    .mcqResultScoreTotal {
        font-size: 28px;
    }

    .mcqResultProgress .ant-progress-circle {
        width: 140px !important;
        height: 140px !important;
    }

    .mcqResultButton {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .mcqResultContainer {
        padding: 20px 16px;
    }

    .mcqResultCard .ant-card-body {
        padding: 24px !important;
    }

    .mcqResultIconWrapper {
        width: 80px;
        height: 80px;
    }

    .mcqResultIcon {
        font-size: 40px !important;
    }

    .mcqResultTitle {
        font-size: 24px;
    }

    .mcqResultSubtitle {
        font-size: 14px;
    }

    .mcqResultScoreCard {
        padding: 24px;
    }

    .mcqResultScoreValue {
        font-size: 40px;
    }

    .mcqResultScoreDivider {
        font-size: 36px;
    }

    .mcqResultScoreTotal {
        font-size: 24px;
    }

    .mcqResultProgressSection {
        padding: 24px;
    }

    .mcqResultProgress .ant-progress-circle {
        width: 120px !important;
        height: 120px !important;
    }

    .mcqResultButton {
        height: 48px !important;
        font-size: 16px !important;
        padding: 0 32px !important;
    }
}




`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/ManualAssessment/ScoreAndReviewPage/ManualResult.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8FAA8F;IAC9F,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+CAA+C;IAC/C,wCAAwC;AAC5C;;AAEA;IACI;QACI,mBAAmB;QACnB,+CAA+C;IACnD;IACA;QACI,sBAAsB;QACtB,gDAAgD;IACpD;AACJ;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8FAA8F;IAC9F,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA,kBAAkB;AAClB;IACI,cAAc;AAClB;;AAEA;IACI,gGAAgG;IAChG,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wEAAwE;IACxE,uBAAuB;IACvB,0DAA0D;IAC1D,oCAAoC;IACpC,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;QACvB,0BAA0B;QAC1B,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Modern MCQ Result Page */\n\n.mcqResultContainer {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.mcqResultContent {\n    width: 100%;\n    max-width: 800px;\n}\n\n.mcqResultCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 24px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n    transition: all 0.3s ease !important;\n}\n\n.mcqResultCard:hover {\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;\n}\n\n.mcqResultCard .ant-card-body {\n    padding: 48px !important;\n}\n\n/* Celebration Section */\n.mcqResultCelebration {\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.mcqResultIconWrapper {\n    width: 120px;\n    height: 120px;\n    margin: 0 auto 24px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 2px solid rgba(102, 126, 234, 0.2);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0%, 100% {\n        transform: scale(1);\n        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n    }\n    50% {\n        transform: scale(1.05);\n        box-shadow: 0 12px 32px rgba(102, 126, 234, 0.3);\n    }\n}\n\n.mcqResultIcon {\n    font-size: 64px !important;\n    color: #667eea !important;\n}\n\n.mcqResultTitle {\n    font-size: 36px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 12px 0;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.mcqResultSubtitle {\n    font-size: 18px;\n    color: #6b7280;\n    margin: 0;\n    font-weight: 400;\n}\n\n/* Feedback Timer */\n.mcqResultFeedbackTimer {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 20px 24px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    border-radius: 16px;\n    margin-bottom: 32px;\n}\n\n.mcqResultFeedbackTimerIcon {\n    font-size: 32px !important;\n    color: #667eea !important;\n}\n\n.mcqResultFeedbackTimerContent {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.mcqResultFeedbackTimerLabel {\n    font-size: 14px;\n    color: #6b7280;\n    font-weight: 500;\n}\n\n.mcqResultFeedbackTimerValue {\n    font-size: 24px;\n    font-weight: 700;\n    color: #f5576c;\n    font-variant-numeric: tabular-nums;\n}\n\n/* Score Section */\n.mcqResultScoreSection {\n    margin: 32px 0;\n}\n\n.mcqResultScoreCard {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n    border: 2px solid rgba(102, 126, 234, 0.2);\n    border-radius: 20px;\n    padding: 32px;\n    text-align: center;\n    margin-bottom: 32px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);\n}\n\n.mcqResultScoreCard.descriptionType {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    padding: 40px;\n}\n\n.mcqResultCheckIcon {\n    font-size: 64px !important;\n    color: #10b981 !important;\n}\n\n.mcqResultDescriptionText {\n    font-size: 18px;\n    color: #1f2937;\n    margin: 0;\n    font-weight: 500;\n}\n\n.mcqResultScoreDisplay {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.mcqResultScoreValue {\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.mcqResultScoreDivider {\n    font-size: 48px;\n    font-weight: 400;\n    color: #9ca3af;\n}\n\n.mcqResultScoreTotal {\n    font-size: 36px;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.mcqResultScoreLabel {\n    font-size: 16px;\n    color: #6b7280;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Progress Section */\n.mcqResultProgressSection {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    padding: 32px;\n    background: rgba(102, 126, 234, 0.02);\n    border-radius: 16px;\n    border: 1px solid rgba(102, 126, 234, 0.1);\n}\n\n.mcqResultProgressCircle {\n    flex-shrink: 0;\n}\n\n.mcqResultProgressInfo {\n    flex: 1;\n}\n\n.mcqResultProgressInfo .ant-statistic-title {\n    font-size: 16px;\n    color: #6b7280;\n    font-weight: 500;\n    margin-bottom: 8px;\n}\n\n.mcqResultPerformanceText {\n    font-size: 16px;\n    color: #4b5563;\n    line-height: 1.6;\n    margin-top: 16px;\n    margin-bottom: 0;\n}\n\n/* Actions */\n.mcqResultActions {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    padding-top: 32px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.mcqResultButton {\n    height: 56px !important;\n    padding: 0 48px !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    border-radius: 16px !important;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;\n    transition: all 0.3s ease !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 12px !important;\n}\n\n.mcqResultButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;\n}\n\n.mcqResultButton:active {\n    transform: translateY(0);\n}\n\n/* Legacy Styles (for compatibility) */\n.result-container {\n    display: none;\n}\n\n.result-card {\n    display: none;\n}\n\n.thanks {\n    display: none;\n}\n\n.completed {\n    display: none;\n}\n\n.score {\n    display: none;\n}\n\n.back-to-dashboard {\n    display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n    .mcqResultContainer {\n        padding: 30px 40px;\n    }\n\n    .mcqResultCard .ant-card-body {\n        padding: 40px !important;\n    }\n\n    .mcqResultProgressSection {\n        flex-direction: column;\n        gap: 24px;\n        text-align: center;\n    }\n\n    .mcqResultProgressInfo {\n        width: 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .mcqResultContainer {\n        padding: 30px 20px;\n    }\n\n    .mcqResultCard .ant-card-body {\n        padding: 32px !important;\n    }\n\n    .mcqResultIconWrapper {\n        width: 100px;\n        height: 100px;\n    }\n\n    .mcqResultIcon {\n        font-size: 52px !important;\n    }\n\n    .mcqResultTitle {\n        font-size: 28px;\n    }\n\n    .mcqResultSubtitle {\n        font-size: 16px;\n    }\n\n    .mcqResultScoreValue {\n        font-size: 48px;\n    }\n\n    .mcqResultScoreTotal {\n        font-size: 28px;\n    }\n\n    .mcqResultProgress .ant-progress-circle {\n        width: 140px !important;\n        height: 140px !important;\n    }\n\n    .mcqResultButton {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 480px) {\n    .mcqResultContainer {\n        padding: 20px 16px;\n    }\n\n    .mcqResultCard .ant-card-body {\n        padding: 24px !important;\n    }\n\n    .mcqResultIconWrapper {\n        width: 80px;\n        height: 80px;\n    }\n\n    .mcqResultIcon {\n        font-size: 40px !important;\n    }\n\n    .mcqResultTitle {\n        font-size: 24px;\n    }\n\n    .mcqResultSubtitle {\n        font-size: 14px;\n    }\n\n    .mcqResultScoreCard {\n        padding: 24px;\n    }\n\n    .mcqResultScoreValue {\n        font-size: 40px;\n    }\n\n    .mcqResultScoreDivider {\n        font-size: 36px;\n    }\n\n    .mcqResultScoreTotal {\n        font-size: 24px;\n    }\n\n    .mcqResultProgressSection {\n        padding: 24px;\n    }\n\n    .mcqResultProgress .ant-progress-circle {\n        width: 120px !important;\n        height: 120px !important;\n    }\n\n    .mcqResultButton {\n        height: 48px !important;\n        font-size: 16px !important;\n        padding: 0 32px !important;\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
